
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer" dir="rtl">
      <div className="footer-container">

        <div className="footer-column footer-brand-column">
          <div className="footer-lawyer-logo">
            <Link to="/" aria-label="רז יוסף – חזרה לעמוד הבית">
              <img
                src="/logo192.png"
                alt="רז יוסף – משרד עורכי דין"
                loading="lazy"
              />
            </Link>
          </div>

          <p className="footer-brand-description">
            משרד עורכי דין רז יוסף מעניק ליווי וייצוג משפטי אישי,
            מקצועי ודיסקרטי בתחומי דיני המשפחה, הגירושין,
            הצוואות והירושות.
          </p>

          <div className="footer-brand-highlight">
            ניסיון, מקצועיות ויחס אישי לכל לקוח
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">ניווט באתר</h3>
          <ul className="footer-inline-list">
            <li><Link to="/">עמוד הבית</Link></li>
            <li><Link to="/Initial_Legal_Guidance">ייעוץ משפטי ראשוני</Link></li>
            <li><Link to="/About">אודות המשרד</Link></li>
            <li><Link to="/ContactSection2">צור קשר</Link></li>
            <li><Link to="/Privacy_Policy">מדיניות פרטיות</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">גירושין  </h3>
          <ul className="footer-inline-list">
            <li><Link to="/Property_Distribution_and_Resource_Balancing">חלוקת רכוש ואיזון משאבים</Link></li>
            <li><Link to="/Parental_Responsibility_and_Visitation_Time">אחריות הורית וזמני שהות</Link></li>
            <li><Link to="/Child_Support_and_Wife_Support">מזונות ילדים ומזונות אישה</Link></li>
            <li><Link to="/Matters_of_the_Rabbinical_Court">ענייני בית הדין הרבני</Link></li>
            <li><Link to="/Divorce_and_Mediation_Agreements">הסכמי גירושין וגישור</Link></li>
            <li><Link to="/Urgent_Orders_and_Protection">צווים דחופים והגנה</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">  דיני משפחה וירושה</h3>
          <ul className="footer-inline-list">
            <li><Link to="/The_race_for_authority">מרוץ הסמכויות</Link></li>
            <li><Link to="/International_Divorce">גירושין בינלאומיים</Link></li>
            <li><Link to="/Civil_Marriage_and_Invalid_Marriage">נישואין אזרחיים ופסולי חיתון</Link></li>
            <li><Link to="/Torts_Claims_Between_Spouses">תביעות נזיקין בין בני זוג</Link></li>
            <li><Link to="/Prenuptial_Relations_and_Wills_in_Divorce">יחסי ממון וצוואות בהליכי גירושין</Link></li>
            <li><Link to="/Guardianship_and_Parental_Alienation">אפוטרופסות וניכור הורי</Link></li>
            <li><Link to="/Common_Law_Partners_and_Surrogate_Family_Units">ידועים בציבור ותאים משפחתיים חלופיים</Link></li>
            <li><Link to="/Enduring_Power_of_Attorney">ייפוי כוח מתמשך</Link></li>
          </ul>
        </div>

        <div className="footer-column contact-column">
          <h3 className="footer-title">פרטי התקשרות</h3>

          <div className="footer-contact-item">
            <strong>כתובת</strong>
            <a
              href="https://www.google.com/maps/search/?api=1&query=רחוב+האורזים+23+נתניה"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="הצגת כתובת משרד עורכי הדין במפות Google"
            >
              רחוב האורזים 23, נתניה
            </a>
          </div>

          <div className="footer-contact-item">
            <strong>ניווט למשרד</strong>
            <a
              href="https://waze.com/ul?q=רחוב%20האורזים%2023%20נתניה&navigate=yes"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="ניווט למשרד באמצעות Waze"
            >
              ניווט באמצעות Waze
            </a>
          </div>

          <div className="footer-contact-item">
            <strong>טלפון</strong>
            <a  dir="ltr" aria-label="התקשרות למשרד">
              050-757-5775
            </a>
          </div>

          <div className="footer-contact-item">
            <strong>דוא"ל</strong>
            <a
              href="mailto:raz290174@gmail.com"
              dir="ltr"
              aria-label="שליחת דואר אלקטרוני למשרד"
            >
              raz290174@gmail.com
            </a>
          </div>

          <div className="footer-contact-item">
            <strong>שעות פעילות</strong>
            <span>ימים א׳–ה׳: 09:00–17:00</span>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">

          <div className="footer-copyright">
            © {new Date().getFullYear()} רז יוסף – משרד עורכי דין.
            כל הזכויות שמורות
          </div>

          <div className="footer-bottom-links">
            <Link to="/Privacy_Policy">מדיניות פרטיות</Link>
            <Link to="/ContactSection2">צור קשר</Link>
          </div>

        </div>
      </div>

      <div className="footer-developer">
        <span>עיצוב ופיתוח אתר</span>
        <a
          href="https://siteb2b.co.il/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="SITE B2B – בניית אתרים"
        >
          <img
            src="/logooo.png"
            alt="SITE B2B"
            loading="lazy"
          />
        </a>
      </div>

    </footer>
  );
}
